import TestSentenceScene from "./scenes/Debugger/TestSentenceScene";
import Game from "./scenes/game/Game";
import Intro from "./scenes/intro/Intro";
import Museum from "./scenes/museum/Museum";

export default {
  scenes: [Intro, Game, Museum, TestSentenceScene],
  startScene: Intro.KEY,

  initScene: 'Intro', //"Intro", "Game", "Museum"
  showTutorial: true,
  gameOver: false,
  gamePaused: false,
  gameMuted: false,
  jingleOn: false,
  round: 1,
  score: 0,

  blockConfig: [
    { word: null, ind: 0, col: 0, row: 0, type: null, x: -60, y: -165 },
    { word: null, ind: 0, col: 1, row: 0, type: null, x: 60, y: -165 },

    { word: null, ind: 0, col: 0, row: 1, type: null, x: -140, y: -83 },
    { word: null, ind: 0, col: 1, row: 1, type: null, x: 140, y: -83 },
    { word: null, ind: 0, col: 2, row: 1, type: null, x: 0, y: -83 },

    { word: null, ind: 0, col: 0, row: 2, type: null, x: 170, y: 0 },
    { word: null, ind: 0, col: 1, row: 2, type: null, x: 57, y: 0 },
    { word: null, ind: 0, col: 2, row: 2, type: null, x: -57, y: 0 },
    { word: null, ind: 0, col: 3, row: 2, type: null, x: -170, y: 0 },

    { word: null, ind: 0, col: 0, row: 3, type: null, x: 0, y: 83 },
    { word: null, ind: 0, col: 1, row: 3, type: null, x: -140, y: 83 },
    { word: null, ind: 0, col: 2, row: 3, type: null, x: 140, y: 83 },

    { word: null, ind: 0, col: 0, row: 4, type: null, x: -60, y: 165 },
    { word: null, ind: 0, col: 1, row: 4, type: null, x: 60, y: 165 },
  ],

  duoBlockConfig: [
    { word: null, ind: 0, col: 0, row: 0, type: null, x: -100, y: -80 },
    { word: null, ind: 0, col: 1, row: 0, type: null, x: 100, y: -80 }
  ],

  artifacts: [
    { missing: "AfricanMask_Missing", large: "AfricanMask_Large", small: "AfricanMask", x: 600, y: 85, title: "artifacts.lega_mask.title", info: "artifacts.lega_mask.info", dir: "portrait" },
    { missing: "Ankh_Missing", large: "Ankh_Large", small: "Ankh", x: 775, y: 290, title: "artifacts.ankh.title", info: "artifacts.ankh.info", dir: "portrait" },
    { missing: "Chalice_Missing", large: "Chalice_Large", small: "Chalice", x: 337, y: 270, title: "artifacts.chalice.title", info: "artifacts.chalice.info", dir: "portrait" },
    { missing: "Column_Missing", large: "Column_Large", small: "Column", x: 325, y: 570, title: "artifacts.column.title", info: "artifacts.column.info", dir: "portrait" },
    { missing: "Crown_Missing", large: "Crown_Large", small: "Crown", x: 463, y: 75, title: "artifacts.crown.title", info: "artifacts.crown.info", dir: "portrait" },
    { missing: "Dante_Missing", large: "Dante_Large", small: "Dante", x: 720, y: 550, title: "artifacts.dante.title", info: "artifacts.dante.info", dir: "portrait" },
    { missing: "FabergeEgg_Missing", large: "FabergeEgg_Large", small: "FabergeEgg", x: 355, y: 420, title: "artifacts.egg.title", info: "artifacts.egg.info", dir: "portrait" },
    { missing: "Headdress_Missing", large: "Headdress_Large", small: "Headdress", x: 220, y: 425, title: "artifacts.warbonnet.title", info: "artifacts.warbonnet.info", dir: "landscape" },
    { missing: "JadeDog_Missing", large: "JadeDog_Large", small: "JadeDog", x: 675, y: 268, title: "artifacts.dog.title", info: "artifacts.dog.info", dir: "portrait" },
    { missing: "Katana_Missing", large: "Katana_Large", small: "Katana", x: 510, y: 170, title: "artifacts.katana.title", info: "artifacts.katana.info", dir: "landscape" },
    { missing: "Lamp_Missing", large: "Lamp_Large", small: "Lamp", x: 630, y: 420, title: "artifacts.lamp.title", info: "artifacts.lamp.info", dir: "landscape" },
    { missing: "MayanMask_Missing", large: "MayanMask_Large", small: "MayanMask", x: 310, y: 90, title: "artifacts.mixtec_mask.title", info: "artifacts.mixtec_mask.info", dir: "landscape" },
    { missing: "Painting_Missing", large: "Painting_Large", small: "Painting", x: 505, y: 272, title: "artifacts.still_life.title", info: "artifacts.still_life.info", dir: "landscape" },
    { missing: "RaptorSkull_Missing", large: "RaptorSkull_Large", small: "RaptorSkull", x: 770, y: 68, title: "artifacts.skull.title", info: "artifacts.skull.info", dir: "landscape" },
    { missing: "Rug_Missing", large: "Rug_Large", small: "Rug", x: 515, y: 665, title: "artifacts.rug.title", info: "artifacts.rug.info", dir: "landscape" },
    { missing: "Spear_Missing", large: "Spear_Large", small: "Spear", x: 530, y: 365, title: "artifacts.spear.title", info: "artifacts.spear.info", dir: "landscape" },
    { missing: "Sword_Missing", large: "Sword_Large", small: "Sword", x: 560, y: 510, title: "artifacts.sword.title", info: "artifacts.sword.info", dir: "landscape" },
    { missing: "TricornHat_Missing", large: "TricornHat_Large", small: "TricornHat", x: 810, y: 377, title: "artifacts.tricorn.title", info: "artifacts.tricorn.info", dir: "landscape" },
    { missing: "Telephone_Missing", large: "Telephone_Large", small: "Telephone", x: 230, y: 205, title: "artifacts.phone.title", info: "artifacts.phone.info", dir: "landscape" },
    { missing: "Vase_Missing", large: "Vase_Large", small: "Vase", x: 465, y: 520, title: "artifacts.vase.title", info: "artifacts.vase.info", dir: "portrait" }
  ],

  collectedArtifacts: [],

  pastVerbs: [],
  presentVerbs: [],
  sentences: [],
  combined: []
}